import { useEffect, useState } from 'react';

type Status = 'idle' | 'loading' | 'ready' | 'error';

export type StyleProps = {
    href: string;
    removeFlag?: boolean;
};

export const useStyle = ({ href, removeFlag = false }: StyleProps) => {
    const [status, setStatus] = useState<Status>(href ? 'loading' : 'idle');

    useEffect(() => {
        if (!href) {
            setStatus('idle');
            return;
        }

        // 1. 동일한 url로 생성된 link 태그 확인
        let link: HTMLLinkElement | null = document.querySelector(`link[href="${href}"`);

        if (!link) {
            link = document.createElement('link');
            link.href = href;
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.setAttribute('data-status', 'loading');
            document.head.appendChild(link);

            const setAttributeFromEvent = (e: Event) => {
                const newStatus: Status = e.type === 'load' ? 'ready' : 'error';
                link?.setAttribute('data-status', newStatus);
                setStatus(newStatus);
            };

            link.addEventListener('load', setAttributeFromEvent);
            link.addEventListener('error', setAttributeFromEvent);
        } else {
            setStatus((link.getAttribute('data-status') as Status) ?? 'ready');
        }

        const setStatusFromEvent = (e: Event) => {
            setStatus(e.type === 'load' ? 'ready' : 'error');
        };

        link.addEventListener('load', setStatusFromEvent);
        link.addEventListener('error', setStatusFromEvent);

        return () => {
            // TODO: 언마운트시 기존 css 제거 여부
            if (link) {
                if (removeFlag) {
                    link.remove();
                } else {
                    link.removeEventListener('load', setStatusFromEvent);
                    link.removeEventListener('error', setStatusFromEvent);
                }
            }
        };
    }, [href]);

    return { status };
};
